import {Table, Button, Input, DatePicker, Image, Checkbox, Select} from 'antd';
import React, {useEffect, useCallback, useState} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {Link/*, useHistory*/} from 'react-router-dom';
//import SliderNextIcon from '../../../../components/Common/Icons/sliderNext';
import {
    setDealerCars,
    setDealerCarImages, setSubDealers,
} from '../../../../redux/Reducers/dealerCarsReducer';
import style from './style.module.scss';
import * as moment from 'moment';
import {DownloadOutlined} from '@ant-design/icons';
import {getDealerCarImages/*, putCarToMarket*/} from '../../../../api/requests';
import {saveAs} from 'file-saver';

const {Search} = Input;
const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:4000';

const BoughtCars = () => {
    /* const history = useHistory();*/
    const [downloading, setDownloading] = useState({});
    /*const [processingMarket, setProcessingMarket] = useState({});*/

    const handleDownloadZip = (id) => {
        setDownloading({...downloading, [id]: true});
        getDealerCarImages(id).then((response) => {
            if (response && response.data && response.data !== 'images not found') {
                saveAs(response.data, `car_${id}.zip`);
            }
            setDownloading({...downloading, [id]: false});
        });
    };
    // const handleToMarket = (id) => {
    //   setProcessingMarket({...processingMarket, [id]: true});
    //   putCarToMarket(id).then((response) => {
    //     if (response && response.data && response.data.success) {
    //       const car = response.data.car;
    //       if(car) {
    //         history.push({pathname: `/sell/${car.id}`, state: {makeId: car.make, modelId: car.model}});
    //       }
    //     }
    //     setProcessingMarket({...processingMarket, [id]: false});
    //   });
    // };
    const dealerCars = useSelector(
        (state) => state.dealerCars.boughtCars,
        shallowEqual,
    );
    const subDealers = useSelector(
        (state) => state.dealerCars.subDealers,
        shallowEqual,
    );
    const pagination = useSelector(
        (state) => state.dealerCars.pagination,
        shallowEqual,
    );
    const loading = useSelector(
        (state) => state.dealerCars.loading,
        shallowEqual,
    );
    const sorter = useSelector((state) => state.dealerCars.sorter, shallowEqual);
    const filters = useSelector(
        (state) => state.dealerCars.filters,
        shallowEqual,
    );
    const searchElements = useSelector(
        (state) => state.dealerCars.searchElements,
        shallowEqual,
    );
    const previewImages = useSelector(
        (state) => state.dealerCars.previewImages,
        shallowEqual,
    );
    const [searchItems, setSearchItems] = useState({
        vin: null,
        lot: null,
        date: null,
        myCars: false,
        dealerId: null,
    });

    const dispatch = useDispatch();
    // const locationRegex = /\(.*\)/g;
    const HandleChange = useCallback(
        (pagination, filters, sorter, searchElements = {}) => {
            if (searchItems.vin) {
                searchElements.vin = searchItems.vin;
            }
            if (searchItems.lot) {
                searchElements.lot = searchItems.lot;
            }
            if (searchItems.date) {
                searchElements.date = searchItems.date;
            }
            if (searchItems.myCars) {
                searchElements.myCars = searchItems.myCars;
            }
            if (searchItems.dealerId) {
                searchElements.dealerId = searchItems.dealerId;
            }
            dispatch(setDealerCars(pagination, filters, sorter, searchElements));
        },
        [dispatch, searchItems],
    );
    const vinSearch = (vin) => {
        setSearchItems(prevState => {
            // Object.assign would also work
            prevState.vin = vin;
            return {...prevState};
        });
        pagination.current = 1;
        HandleChange(pagination, filters, sorter, searchItems);
    };
    const lotSearch = (lot) => {
        setSearchItems(prevState => {
            // Object.assign would also work
            prevState.lot = lot;
            return {...prevState};
        });
        pagination.current = 1;
        HandleChange(pagination, filters, sorter, searchItems);
    };
    const dateSearch = (date) => {
        setSearchItems(prevState => {
            // Object.assign would also work
            prevState.date = date ? moment(date).format('YYYY-MM-DD') : null;
            return {...prevState};
        });
        pagination.current = 1;
        HandleChange(pagination, filters, sorter, searchItems);
    };

    const subDealerSearch = (dealerId) => {
        setSearchItems(prevState => {
            // Object.assign would also work
            prevState.dealerId = dealerId;
            return {...prevState};
        });
        pagination.current = 1;
        HandleChange(pagination, filters, sorter, searchItems);
    }

    const setMyCars = (myCars) => {
        setSearchItems(prevState => {
            // Object.assign would also work
            prevState.myCars = myCars;
            return {...prevState};
        });
        pagination.current = 1;
        HandleChange(pagination, filters, sorter, searchItems);
    }
    const resetFilters = () => {
        setSearchItems({
            vin: null,
            lot: null,
            date: null,
            myCars: false,
            dealerId: null,
        });
        pagination.current = 1;
        HandleChange(pagination, filters, sorter, searchItems);
    }
    const showImage = (data) => {
        dispatch(setDealerCarImages(data));
    };

    function handleResize() {
        setWidth(window.innerWidth - 20);
    }

    const [width, setWidth] = useState(1024);
    const div = useCallback(node => {
        if (node !== null) {
            //setWidth(node.getBoundingClientRect().width);
        }

    }, []);

    useEffect(() => {
        HandleChange(pagination, filters, sorter, searchElements);
        setSubDealers()(dispatch);
        handleResize()
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const columns = [
        {
            title: 'Image',
            dataIndex: 'carMedia',
            key: 'carMedia',
            width: 75,
            render: (data) => {
                const firstMedia =
                    data &&
                    data.length > 0 &&
                    BASE_URL +
                    data[0].carImage.location +
                    '/' +
                    data[0].carImage.name +
                    'small.jpeg';
                return (
                    <div>
                        <Image
                            preview={{visible: false}}
                            width={50}
                            height={50}
                            src={data && data.length > 0 ? firstMedia : 'error'}
                            fallback="data:image/png;base64,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"
                            onClick={() => showImage(data)}
                        />
                    </div>
                );
            },
        },
        {
            title: 'Make',
            dataIndex: 'carMake',
            key: 'carMake',
            width: 90,
            render: (object, record) => (
                <React.Fragment>{object?.name}</React.Fragment>
            ),
        },
        {
            title: 'Model',
            dataIndex: 'carModel',
            key: 'carModel',
            width: 90,
            render: (object, record) => (
                <React.Fragment>{object?.name}</React.Fragment>
            ),
        },
        {
            title: 'VIN',
            dataIndex: 'vin',
            key: 'vin',
            width: 180,
        },
        {
            title: 'LOT',
            dataIndex: 'lot',
            key: 'lot',
            width: 90,
            render: (text, record) => (
                <React.Fragment>
                    {record.buy_source.toLowerCase() === 'iaai' ? (
                        text
                    ) : (
                        <a
                            href={`https://www.copart.com/lot/${text}`}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {text}
                        </a>
                    )}
                </React.Fragment>
            ),
        },
        {
            title: 'Bought source',
            dataIndex: 'buy_source',
            key: 'buy_source',
            width: 75,
        },
        {
            title: 'Bought day',
            dataIndex: 'buy_day',
            key: 'buy_day',
            width: 90,
            render: (text, record) => (
                <React.Fragment>
                    {text && moment(text, 'YYYY.MM.DD').format('YYYY-MM-DD')}
                </React.Fragment>
            ),
        },
        {
            title: 'SHIPPING LINE',
            key: 'shipping_line',
            width: 100,
            render: (record) => (
                <React.Fragment>
                    <b>
                        <a href={record.trucking_url} target="_blank" rel="noreferrer">
                            {record.shipping_line || '-'}
                        </a>
                    </b>
                </React.Fragment>
            ),
        },
        {
            title: 'Booking No.',
            dataIndex: 'booking_number',
            key: 'booking_number',
            width: 150,
            render: (text) => <React.Fragment>{text || '-'}</React.Fragment>,
        },
        {
            title: 'Container No.',
            dataIndex: 'container_number',
            key: 'container_number',
            width: 150,
            render: (text) => <React.Fragment>{text || '-'}</React.Fragment>,
        },
        {
            title: 'Final Destination',
            dataIndex: 'final_destination',
            key: 'final_destination',
            width: 100,
        },
        {
            title: 'Tools',
            key: 'tools',
            fixed: 'right',
            width: 200,
            render: (data) => {
                const isMediaExists = data && data.carMedia && data.carMedia.length > 0;
                return (
                    <React.Fragment>
                        {isMediaExists && (
                            <Button
                                type="link"
                                icon={<DownloadOutlined/>}
                                loading={downloading[data.id]}
                                onClick={() => handleDownloadZip(data.key)}
                            >
                                Images
                            </Button>
                        )}
                        <Link to={`/dealer/car/${data.key}`}>
                            <Button type="primary">DETAILS</Button>
                        </Link>
                    </React.Fragment>
                );
            },
        },
    ];

    return (
        <div className={style.wrapper} ref={div}>
            <div className={style.dealerCarFilters}>
                <Search
                    placeholder="VIN search"
                    onSearch={vinSearch}
                    style={{width: 200}}
                />
                <Search
                    placeholder="LOT search"
                    onSearch={lotSearch}
                    style={{width: 200}}
                />
                <DatePicker onChange={dateSearch}/>
                <Checkbox onChange={(e) => setMyCars(e.target.checked)}>My cars</Checkbox>
                <Select
                    showSearch
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    placeholder="Sub dealer" onChange={subDealerSearch}>
                    <Select.Option key={'empty'} value={''}>
                        &nbsp;
                    </Select.Option>
                    {subDealers.map((dealer) => {
                            return (
                                <Select.Option key={dealer.key} value={dealer.key}>
                                    {dealer.dealerName}
                                </Select.Option>
                            );
                        }
                    )}
                </Select>
                <Button onClick={resetFilters}>Reset filters</Button>
            </div>
            <div style={{display: 'none'}}>
                <Image.PreviewGroup
                    preview={{
                        visible: !!previewImages.length,
                        onVisibleChange: () => showImage([]),
                    }}
                >
                    {previewImages.map((image) => {
                        return (
                            <Image
                                src={
                                    BASE_URL +
                                    image.carImage.location +
                                    '/' +
                                    image.carImage.name +
                                    'large.jpeg'
                                }
                                key={image.carImage.name}
                            />
                        );
                    })}
                </Image.PreviewGroup>
            </div>
            <div style={{overflow: 'auto'}}>
                <Table
                    columns={columns}
                    scroll={{x: true}}
                    style={{maxWidth: width}}
                    dataSource={dealerCars}
                    pagination={pagination}
                    bordered
                    loading={loading}
                    onChange={HandleChange}
                />
            </div>
        </div>
    );
};

export default BoughtCars;
